import { useCallback, useInsertionEffect, useRef } from "react";

export function useEffectEvent(fn: Function) {
  const ref = useRef<Function>();
  useInsertionEffect(() => {
    ref.current = fn;
  }, [fn]);
  return useCallback((...args: any[]) => {
    const f = ref.current!;
    return f(...args);
  }, []);
}
